function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

var _ref = /*#__PURE__*/React.createElement("g", {
  filter: "url(#filter0_dd)"
}, /*#__PURE__*/React.createElement("circle", {
  cx: 27.0007,
  cy: 20.0007,
  r: 12.7273,
  fill: "white"
}));

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M24.739 25.768L24.7391 25.768C24.8617 25.896 25.0516 25.896 25.1743 25.768L24.739 25.768ZM24.739 25.768L19.4209 20.2211C19.2868 20.0813 19.2868 19.8462 19.4209 19.7063C19.4209 19.7063 19.4209 19.7063 19.4209 19.7063L20.5779 18.4995L20.5779 18.4995C20.7006 18.3715 20.8905 18.3715 21.0132 18.4995L21.0132 18.4995L24.5958 22.2361L24.9567 22.6125L25.3176 22.2361L32.9911 14.2327L32.6302 13.8867L32.9911 14.2327C33.1138 14.1047 33.3037 14.1047 33.4263 14.2327L34.5834 15.4395L34.9443 15.0935L34.5834 15.4395C34.7174 15.5793 34.7175 15.8144 34.5834 15.9543C34.5834 15.9543 34.5834 15.9543 34.5834 15.9543L25.1743 25.768L24.739 25.768Z",
  fill: "#E1E1E1",
  stroke: "#E1E1E1"
});

var _ref3 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
  id: "filter0_dd",
  x: 0.273438,
  y: 1.27344,
  width: 53.4545,
  height: 45.4545,
  filterUnits: "userSpaceOnUse",
  colorInterpolationFilters: "sRGB"
}, /*#__PURE__*/React.createElement("feFlood", {
  floodOpacity: 0,
  result: "BackgroundImageFix"
}), /*#__PURE__*/React.createElement("feColorMatrix", {
  in: "SourceAlpha",
  type: "matrix",
  values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
}), /*#__PURE__*/React.createElement("feOffset", {
  dx: -4,
  dy: 4
}), /*#__PURE__*/React.createElement("feGaussianBlur", {
  stdDeviation: 5
}), /*#__PURE__*/React.createElement("feColorMatrix", {
  type: "matrix",
  values: "0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 0.6 0"
}), /*#__PURE__*/React.createElement("feBlend", {
  mode: "normal",
  in2: "BackgroundImageFix",
  result: "effect1_dropShadow"
}), /*#__PURE__*/React.createElement("feColorMatrix", {
  in: "SourceAlpha",
  type: "matrix",
  values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
}), /*#__PURE__*/React.createElement("feOffset", {
  dx: 4,
  dy: 4
}), /*#__PURE__*/React.createElement("feGaussianBlur", {
  stdDeviation: 5
}), /*#__PURE__*/React.createElement("feColorMatrix", {
  type: "matrix",
  values: "0 0 0 0 0.160784 0 0 0 0 0.176471 0 0 0 0 0.184314 0 0 0 0.1 0"
}), /*#__PURE__*/React.createElement("feBlend", {
  mode: "normal",
  in2: "effect1_dropShadow",
  result: "effect2_dropShadow"
}), /*#__PURE__*/React.createElement("feBlend", {
  mode: "normal",
  in: "SourceGraphic",
  in2: "effect2_dropShadow",
  result: "shape"
})));

const SvgNotSelectCircle = ({
  svgRef,
  title,
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  width: 54,
  height: 47,
  viewBox: "0 0 54 47",
  fill: "none",
  ref: svgRef
}, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref, _ref2, _ref3);

const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgNotSelectCircle, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/not-select-circle.62f9f635.svg";
export { ForwardRef as ReactComponent };